/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PermissionDetailsDto model module.
 * @module model/PermissionDetailsDto
 * @version v1.0.0
 */
class PermissionDetailsDto {
    /**
     * Constructs a new <code>PermissionDetailsDto</code>.
     * @alias module:model/PermissionDetailsDto
     */
    constructor() { 
        
        PermissionDetailsDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PermissionDetailsDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PermissionDetailsDto} obj Optional instance to populate.
     * @return {module:model/PermissionDetailsDto} The populated <code>PermissionDetailsDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PermissionDetailsDto();

            if (data.hasOwnProperty('category')) {
                obj['category'] = ApiClient.convertToType(data['category'], 'String');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
        }
        return obj;
    }


}

/**
 * permission category
 * @member {String} category
 */
PermissionDetailsDto.prototype['category'] = undefined;

/**
 * permission code
 * @member {String} code
 */
PermissionDetailsDto.prototype['code'] = undefined;

/**
 * permission content
 * @member {String} content
 */
PermissionDetailsDto.prototype['content'] = undefined;

/**
 * permission description
 * @member {String} description
 */
PermissionDetailsDto.prototype['description'] = undefined;

/**
 * permission id
 * @member {Number} id
 */
PermissionDetailsDto.prototype['id'] = undefined;

/**
 * permission name
 * @member {String} name
 */
PermissionDetailsDto.prototype['name'] = undefined;

/**
 * permission type
 * @member {String} type
 */
PermissionDetailsDto.prototype['type'] = undefined;






export default PermissionDetailsDto;

